import styled from "styled-components";

export const ContentContainer = styled.div`
  &:not(:last-child) {
    margin-bottom: 18px;
  }
`;
